import React from 'react';
import Styles from './wallet-section-styles.scss';
import classNames from 'classnames';
import IconSavingsView from '@/presentation/components/icons/savings-view';
import { IconButton } from '@/presentation/components';
const WalletSection = ({ title = 'ModuleCurrentItem', subTitle = '', icon: Icon, onClick, viewTitle, children }) => {
    const handleOnClick = () => {
        if (onClick)
            onClick();
    };
    return (React.createElement("div", { className: classNames([Styles.walletWrap]) },
        React.createElement("div", { className: Styles.headerContainer },
            React.createElement("div", { className: Styles.title },
                Icon && React.createElement("div", null, Icon),
                " ",
                React.createElement("div", { className: Styles.mainTitle }, title),
                ' ',
                React.createElement("div", { className: Styles.subTitle }, subTitle)),
            React.createElement("div", { className: Styles.viewTitle }, viewTitle && (React.createElement(React.Fragment, null,
                viewTitle,
                React.createElement(IconButton, { className: Styles.iconSavingsView, onClick: handleOnClick },
                    React.createElement(IconSavingsView, null)))))),
        children));
};
export default WalletSection;
